import React from 'react';

// Props that make a non-native element operable by mouse and keyboard (Enter / Space).
export const keyboardClickable = (onClick: (event: React.SyntheticEvent) => void) => ({
    role: 'button',
    tabIndex: 0,
    onClick,
    onKeyDown: (event: React.KeyboardEvent) => {
        // Ignore keys pressed inside nested controls (inputs, etc.)
        if (event.target !== event.currentTarget) return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick(event);
        }
    },
});
